/** SEO metadata for core marketing pages that previously relied on index.html defaults. */

export const CORE_PAGE_SEO = {
  home: {
    path: '/',
    title: 'Easy Drop Taxi | One Way Drop Taxi Booking in Coimbatore',
    description:
      'Book a one-way drop taxi with Easy Drop Taxi from Coimbatore. Check routes, estimate fares online, and confirm outstation or local corridor trips with the same booking form.',
  },
  about: {
    path: '/about',
    title: 'About Easy Drop Taxi | Coimbatore One Way Taxi Service',
    description:
      'Learn about Easy Drop Taxi, a Coimbatore-based one-way and outstation taxi service focused on reliable bookings, clear fares, and customer-first travel across Tamil Nadu and nearby states.',
  },
  services: {
    path: '/services',
    title: 'Taxi Services | Station, Outstation & City Travel | Easy Drop Taxi',
    description:
      'Book Easy Drop Taxi for railway and airport transfers, one-way outstation cabs, hourly rental, late-night rides, hospital trips, temple tours, city tours, and weddings.',
  },
  tariff: {
    path: '/tariff',
    title: 'Taxi Tariff & Terms | Sedan SUV Crysta Rates | Easy Drop Taxi',
    description:
      'View Easy Drop Taxi published per-kilometre rates for Sedan, SUV and Crysta, plus travel terms. Confirm the live fare estimate in the booking form for your pickup and drop.',
  },
  contact: {
    path: '/contact',
    title: 'Contact EasyDropTaxi | Coimbatore Taxi Booking Support',
    description:
      'Contact EasyDropTaxi in Coimbatore for taxi booking help. Call, email, or WhatsApp about one-way drops, round trips, airport transfers, and outstation travel.',
  },
};
